module.exports = __webpack_public_path__ + "static/media/pulseai.logo3.transparent.74505b0c.png";